import React from 'react'

function Testimonial() {
  return (
    <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Testimonial
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Testimonial
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Testimonial Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Testimonial
          </h6>
          <h1 className="mb-5">Our Clients Say!!!</h1>
        </div>
        <div className="owl-carousel testimonial-carousel position-relative">
          <div className="testimonial-item bg-white text-center border p-4">
            <img 
              alt="Sarah Johnson"
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-1.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">Sarah Johnson</h5>
            <p>New York, USA</p>
            <p className="mb-0">
              Holiday Royal made our honeymoon absolutely perfect! Every detail was taken care of, and we had the most amazing experience. Highly recommend!
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img 
              alt="Michael Chen"
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-2.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">Michael Chen</h5>
            <p>Los Angeles, USA</p>
            <p className="mt-2 mb-0">
              Excellent service from start to finish! The team at Holiday Royal helped us plan an incredible family vacation. Professional, friendly, and reliable.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img 
              alt="Emily Rodriguez"
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-3.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">Emily Rodriguez</h5>
            <p>Miami, USA</p>
            <p className="mt-2 mb-0">
              The attention to detail and personalized service from Holiday Royal was outstanding. They truly understand what makes a perfect vacation!
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img 
              alt="David Thompson"
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-4.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">David Thompson</h5>
            <p>Chicago, USA</p>
            <p className="mt-2 mb-0">
              Best travel agency we've ever used! Holiday Royal made our European tour seamless and unforgettable. Will definitely book with them again!
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* Testimonial End */}
    </div>
  )
}

export default Testimonial
